import React from 'react'
import { IconButton } from '@mui/material'
import TranslateIcon from '@mui/icons-material/Translate'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import useTranslationAvailability from './useTranslationAvailability'
import { useTranslatorWidget } from './TranslatorProvider'

/**
 * Free-text translator entry point in the TopBar (story #119, widget since #2892).
 * Sits next to the language selector and only offers the tool when it is actually usable (RN1).
 * It only *opens* the floating widget; the widget itself is mounted once in MainContainer.
 */
const TranslatorButton = ({ translatorEnabled = false }) => {
  const { t_ } = useSmartTranslation()
  const available = useTranslationAvailability(translatorEnabled)
  const { open } = useTranslatorWidget()

  // GATE 1 nº1: when the tool is not available the button is hidden entirely — never rendered
  // disabled with an explanatory tooltip. With the setting OFF (RN2/A1) MIC looks exactly as it
  // did before the story.
  if (!available) return null

  return (
    <IconButton aria-label={t_('Open translator')} color='inherit' onClick={open}>
      <TranslateIcon />
    </IconButton>
  )
}

export default TranslatorButton
